import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AppComponent} from './app.component';
import {SearchComponent} from './search/search.component';
import { AboutComponent } from './about/about.component';

import {ProfileComponent } from './profile/profile.component';
import {SearchResultsComponent} from './search-results/search-results.component';
import {HomeComponent} from './home/home.component';
import { LoginComponent } from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import { EnrollComponent } from './enroll/enroll.component';
import {AssignmentComponent} from './assignment/assignment.component';
import {AssessmentComponent} from './assessment/assessment.component';
import {NoticeComponent} from './notice/notice.component';
import {EnquiryComponent} from './enquiry/enquiry.component';
import {ContentComponent} from './content/content.component';
import {UserProfileComponent} from './user-profile/user-profile.component';
import {EnrolDetailsComponent} from './enrol-details/enrol-details.component';
import {NoticeListComponent} from './notice-list/notice-list.component';
import {NoticeDetailsComponent} from './notice-details/notice-details.component';
import {ContentListComponent} from './content-list/content-list.component';
import {ContentDetailsComponent} from './content-details/content-details.component';
import {ClassSearchResultComponent} from './class-search-result/class-search-result.component';
import {ViewSearchDetailsComponent} from './view-search-details/view-search-details.component';
import {ViewSearchComponent} from './view-search/view-search.component';
import {MyCoursesComponent} from './my-courses/my-courses.component';
import {ClassDetailsComponent} from './class-details/class-details.component';
import {RegistrationComponent} from './registration/registration.component';
import {OtpComponent} from './otp/otp.component';
import {MakeEnquriyComponent} from './make-enquriy/make-enquriy.component';
import {MakeEnrollComponent} from './make-enroll/make-enroll.component';
import {ClassSearchDetailsComponent} from './class-search-details/class-search-details.component';
import {HowitworksComponent} from './howitworks/howitworks.component';
import {SuccessEnquriyComponent} from './success-enquriy/success-enquriy.component';
import {AboutUsComponent} from './about-us/about-us.component';
import {FaqComponent} from './faq/faq.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ContactusComponent } from './contactus/contactus.component';
import {EnquiryDetailsComponent} from './enquiry-details/enquiry-details.component';
import { TermsComponent } from './terms/terms.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { UsereditComponent } from './useredit/useredit.component';
import { HowItWorksTeacherComponent } from './how-it-works-teacher/how-it-works-teacher.component';
import { DClsDtlsComponent } from './d-cls-dtls/d-cls-dtls.component';
import { CreatePostComponent } from './create-post/create-post.component';
import { MyPostComponent} from './my-post/my-post.component';
import { SuccessPostComponent } from './success-post/success-post.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { HomeScreenNewComponent } from './home-screen-new/home-screen-new.component';
import { ClassSearchResultNewComponent } from './class-search-result-new/class-search-result-new.component';


const routes: Routes = [ 
  
  {
    path: '',
    redirectTo: 'search',
    pathMatch: 'full'
  },
  {
    path: 'search',
    // component:SearchComponent,
    component: HomeScreenNewComponent,
  },
  {
    path: 'home',
    component:DashboardComponent,
  },
  {
    path: 'userprofile',
    component:UserProfileComponent,
  },
  {
    path: 'useredit/:userID',
    component:UsereditComponent,
  },
  {
    path: 'profile/:venID',
    component:ProfileComponent,
  },
  {
    path: 'searchResults/:category/:specialityId/:mode',
    component:SearchResultsComponent,
  },
  {
    path: 'search-class-results/:category/:specialityId',   
    component:ClassSearchResultNewComponent,
  },  
  {
    path: 'search-class-results/:category',   
    component:ClassSearchResultNewComponent,
  },  
  {
    path: 'classprofile/:venId/:id',
    component:ClassSearchDetailsComponent,
  },
  
  {
    path: 'classDetails/:packageId/:scheduleId',    
    component:DClsDtlsComponent,
  },

  {
    path: 'courses',
    component:MyCoursesComponent,
  },  

  {
    path: 'create-post',
    component:CreatePostComponent,
  }, 

  {
    path: 'login',
    component:LoginComponent,
  },
  {
    path: 'register',
    component:RegistrationComponent,
  },
  {
    path: 'create-enquiry/:vendorID/:courseID',
    component:MakeEnquriyComponent,
  },
  {
    path: 'create-enquiry/:vendorID',
    component:MakeEnquriyComponent,
  },
  {
    path: 'create-enrollment/:venID',
    component:MakeEnrollComponent,
  },
  {
    path: 'create-enrollment/:venID/:courseID',
    component:MakeEnrollComponent,
  },
  {
    path: 'success-enquiry/:enquiryID/:partyID/:vendorID',
    component:SuccessEnquriyComponent,
  },
  {
    path: 'otp',
    component:OtpComponent,
  },
  {
    path: 'forgotpassword',
    component:ForgotPasswordComponent,
  },
  {
    path: 'changePassword',
    component:ChangePasswordComponent,
  },
  {
    path: 'dashboard',
    component:DashboardComponent,
  },
  {
    path: 'enrollment',
    component:EnrollComponent,
  },
  {
    path: 'enrollment-details/:vendorID/:scheduleID/:bookingId/:partyID',
    component:EnrolDetailsComponent,
  },
  {
    path: 'assignment',
    component:AssignmentComponent,
  },
  {
    path: 'assessment',
    component:AssessmentComponent,
  },
  {
    path: 'notice',
    component:NoticeComponent,
  },
  {
    path: 'notice-list/:vendorID',
    component:NoticeListComponent,
  },
  {
    path: 'notice-details/:noticeID',
    component:NoticeDetailsComponent,
  },
  {
    path: 'enquiry',
    component:EnquiryComponent,
  },
  {
    path: 'enquiry-details/:enquiryID/:partyID/:vendorID',
    component:EnquiryDetailsComponent,
  },
  {
    path: 'content',
    component:ContentComponent,
  },
  {
    path: 'content-list/:vendorId',
    component:ContentListComponent,
  },
  {
    path: 'content-details/:id',
    component:ContentDetailsComponent,
  },
  {
    path: 'calender',
    component:CalendarComponent,
  },
  {
    path: 'howitworks',
    component:HowitworksComponent,
  },
  {
    path: 'howitworksteacher',
    component:HowItWorksTeacherComponent,
  },
  {
    path: 'about-us',
    component:AboutUsComponent,
  },
  {
    path: 'faq',
    component:FaqComponent,
  },
  {
    path: 'contact-us',
    component:ContactusComponent,
  },
  {
    path: 'terms-and-conditions',
    component:TermsComponent,
  },
  {
    path: 'sidebar',
    component:SidebarComponent,
  },
  {
    path: 'requirements',
    component:MyPostComponent,
  },
  {
    path: 'success-post/:JobId',
    component:SuccessPostComponent,
  },
 
  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
